import { AdsenseConfig } from '@gumtree/shared/src/types/advertising/adsense';

export const UPDATE_ADSENSE_ADS = 'UPDATE_ADSENSE_ADS';

export const updateAdSenseAds = (payload: AdsenseConfig) => ({
    type: UPDATE_ADSENSE_ADS,
    payload,
});

export default function adSenseReducer(
    state = {} as AdsenseConfig,
    action: ReturnType<typeof updateAdSenseAds>
): AdsenseConfig {
    return action.type === UPDATE_ADSENSE_ADS ? { ...state, ...action.payload } : state;
}
